import api from "../../services/api";

export const getInvoices = async (page) => {
    return await api(`/invoices?page=${page}`);
}